import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BuilderTabs from "../../../Layouts/BuilderTabs";
import Loader from "../../../Layouts/Loader/Loader";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import PageInfoAndActionBar from "../../../Layouts/PageInfoAndActionBar";
import { mapArrayToObject } from "../../../commonFunctions/arrayFunc";
import AccessTemplateSelection from "../../../components/BuilderComponents/AccessTemplateSelection";
import NotesAndTags from "../../../components/BuilderComponents/NotesAndTags";
import Input from "../../../components/FormComponents/Input";
import { useAppBlocksContext } from "../../../context/AppBlocksContext";
import { useAxiosContext } from "../../../context/AxiosContext";
import useZTheme from "../../../hooks/useZTheme";
import DetailsviewElementsBar from "../DetailsViewRenderer/Desktop/DetailsviewElementsBar";
import DetailviewLayoutEditor from "../DetailsViewRenderer/Desktop/DetailviewLayoutEditor";
import { RVCAtalogViewForPostioned } from "../RecordsViewRenderer/Desktop/PositionedDesktopRecordview";
import "./Kanban.css";
import KanbanStatesRenderer from "./KanbanStatesRenderer";

const KanbanRenderer = ({ applicationBlockData, handleSaveApplicationBlock, handleCloneApplicationBlock }) => {
  useZTheme(applicationBlockData.device);
  const { currentBlockConfig, setApplicationBlockData, layout, layoutData, nestedGridData } = useAppBlocksContext();
  const { axiosInstance, handleError } = useAxiosContext();
  const [nonSelectedSmStates, setNonSelectedSmStates] = useState([]);
  const [allStates, setAllStates] = useState({});
  const [showNotesModal, setShowNotesModal] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [showOwnerModal, setShowOwnerModal] = useState(false);
  const [dragFromOutside, setDragFromOutside] = useState(false);

  const fetchSingleTable = async () => {
    try {
      setIsLoading(true);
      let { data } = await axiosInstance.get(`/state-machine/${applicationBlockData.config.table_id}`);
      data = data.config;
      const nonSelectArray = data.states.filter(
        (state) => !applicationBlockData.config.data.states.some((currentState) => currentState.id === state.id)
      );

      const { result } = mapArrayToObject(data.states);
      setAllStates(result);
      setNonSelectedSmStates(nonSelectArray);
      setIsLoading(false);
    } catch (error) {
      handleError(error.message);
      navigate("../");
    }
  };
  const handleNotesAndTag = (data, keyName) => {
    const copyBlockData = JSON.parse(JSON.stringify(applicationBlockData));
    copyBlockData[keyName] = data;
    setApplicationBlockData(copyBlockData);
  };

  const handleAccessTemplate = (data) => {
    const copyBlockData = JSON.parse(JSON.stringify(applicationBlockData));
    copyBlockData.access_templates = data;
    setApplicationBlockData(copyBlockData);
    setShowOwnerModal(false);
  };
  const handleDragStart = (e, name, id, type) => {
    setDragFromOutside(true);
    e.dataTransfer.setData("id", id);
    e.dataTransfer.setData("type", type);
    e.dataTransfer.setData("name", name);
  };
  useEffect(() => {
    fetchSingleTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationBlockData.id]);
  if (isLoading) return <Loader />;

  const tabData = [
    {
      label: "Kanban States",
      content: (
        <KanbanStatesRenderer
          nonSelectedSmStates={nonSelectedSmStates}
          setNonSelectedSmStates={setNonSelectedSmStates}
          allStates={allStates}
        />
      )
    },
    {
      label: "Kanban Card",
      content: (
        <div>
          {!applicationBlockData.is_positioned_block ? (
            <div className="d_flex">
              <div className="detailsView_main_section w_100">
                <div className="desktop_draggable_field_outer">
                  <div
                    id="droppableContainerWidth"
                    className={"droppable_container mobile_screen border_radius_medium"}
                    style={{
                      width: "50%",
                      padding: "0px 20px 20px 20px"
                    }}
                  >
                    <DetailviewLayoutEditor
                      dragFromOutside={dragFromOutside}
                      setDragFromOutside={setDragFromOutside}
                      device={applicationBlockData.device}
                      tableID={currentBlockConfig.table_id}
                      tableType={"statemachine"}
                      elements={[applicationBlockData]}
                      variables={[]}
                    />
                  </div>
                </div>
              </div>
              <DetailsviewElementsBar handleDragStart={handleDragStart} />
            </div>
          ) : (
            <KanbanCardEdit />
          )}
        </div>
      )
    }
  ];

  return (
    <div>
      <PageInfoAndActionBar
        pagePath={`Blocks/Kanban/${applicationBlockData.name}`}
        savePage={handleSaveApplicationBlock}
        currentConfig={[currentBlockConfig, applicationBlockData, layout, nestedGridData.current, layoutData.current]}
        pageName="applicationblock"
        clonePage={handleCloneApplicationBlock}
        notesPage={() => setShowNotesModal(!showNotesModal)}
        saveOwner={() => setShowOwnerModal(!showOwnerModal)}
      />

      <div className="kanban_main_page">
        <BuilderTabs tabs={tabData} tabsClass={`activity_tab`} />

        <BuilderModal isOpen={showNotesModal} onClose={() => setShowNotesModal(false)} modalName="Notes and Tags">
          <NotesAndTags
            notesValue={applicationBlockData.description || ""}
            tagValue={applicationBlockData.info_tag || []}
            onChange={handleNotesAndTag}
          />{" "}
        </BuilderModal>
        <BuilderModal
          isOpen={showOwnerModal}
          onClose={() => setShowOwnerModal(false)}
          modalName="Select Access Templates"
        >
          <AccessTemplateSelection
            templates={applicationBlockData.access_templates}
            handleChange={handleAccessTemplate}
          />
        </BuilderModal>
      </div>
    </div>
  );
};

const KanbanCardEdit = () => {
  const { currentBlockConfig, setCurrentBlockConfig, applicationBlockData, layoutConfig, setLayoutConfig } =
    useAppBlocksContext();

  const handleChangeWidth = (e) => {
    const newWidth = parseInt(e.target.value, 10);

    if (isNaN(newWidth) || newWidth <= 0) {
      return;
    }

    setCurrentBlockConfig((prevConfig) => {
      return {
        ...prevConfig,
        data: {
          ...prevConfig.data,
          card_width: newWidth
        }
      };
    });
  };
  return (
    <>
      <div className="position_absolute p_2">
        <Input
          type="number"
          label="Width"
          value={currentBlockConfig?.data?.card_width || 250}
          onChange={handleChangeWidth}
        />
      </div>
      <RVCAtalogViewForPostioned
        width={currentBlockConfig?.data?.card_width || 250}
        height={"100%"}
        layoutConfig={layoutConfig}
        setLayoutConfig={setLayoutConfig}
        device={applicationBlockData.device}
        tableId={currentBlockConfig?.table_id}
        tableType={"statemachine"}
        elements={[applicationBlockData]}
      />
    </>
  );
};

export default KanbanRenderer;
